"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classificationData = require("@seek/classification-data");
const getSummaryForIds = (ids, itemNames) => {
  var _getClassification;
  if (ids.length === 0) {
    return '';
  }
  return ids.length === 1 ? (_getClassification = (0, _classificationData.getClassification)(Number(ids[0]))) === null || _getClassification === void 0 ? void 0 : _getClassification.name() : `${ids.length} ${itemNames}`;
};
const getClassSummary = _ref => {
  let {
    classification,
    subclassification
  } = _ref;
  const classificationIds = classification ? classification.split(',') : [];
  const subclassificationIds = subclassification ? subclassification.split(',') : [];
  if (classificationIds.length <= 1 && subclassificationIds.length === 1) {
    return getSummaryForIds(subclassificationIds, 'Sub-Classifications');
  }
  return getSummaryForIds(classificationIds, 'Classifications');
};
const titleCase = string => {
  return string.split(' ').map(part => part && `${part[0].toUpperCase()}${part.slice(1)}`).join(' ');
};
var _default = (query, locale) => {
  const keywords = query.keywords;
  const keywordSummary = keywords ? titleCase(keywords) : 'Jobs';
  const classSummary = keywords ? '' : getClassSummary(query);
  const what = keywordSummary + (classSummary ? ` in ${classSummary}` : '');
  const where = query.where || (/^nz$/i.test(locale) ? 'NZ' : 'Australia');
  return `${what} in ${where}`;
};
exports.default = _default;